import * as React from "react";
import {useContext} from "react";
import {Hello} from "../Hello";
import {Dropdown_SelectUnit} from "@components/Dropdown_SelectUnit";
import {RenderRSDownloadLink} from "./units/Component_Btns_Home";
import {UserPermissionContext} from "../App";

export const Page_Home = () => {
    const {userPermission} = useContext(UserPermissionContext);

    if (!userPermission)
        return <div className="ll_v_c">Loading...</div>;

    if (!Object.keys(userPermission).length) {
        return <div className="ll_v_c">You have no permissions</div>;
    }

    return <div className="ll_v_c">
        <Hello/>
        {userPermission.units?.read?.unitIds?.length && <>
            <Dropdown_SelectUnit/>
            <RenderRSDownloadLink/>
        </>}
    </div>;
}
